import { render, staticRenderFns } from "./SMSWizard.vue?vue&type=template&id=84b6bd70&scoped=true&"
import script from "./SMSWizard.vue?vue&type=script&lang=js&"
export * from "./SMSWizard.vue?vue&type=script&lang=js&"
import style0 from "./SMSWizard.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./SMSWizard.vue?vue&type=style&index=1&id=84b6bd70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84b6bd70",
  null
  
)

export default component.exports